import { useFormatter } from 'next-intl';

export const FormattedDate = ({dateString}:{dateString:string}) => {
  const date = new Date(dateString);

  return date && (
    <label>{formatHumanDate(date)}</label>
  );
}

export function formatHumanDate(date: Date): string {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  if (diffDays < 1) {
    const diffHours = diffMs / (1000 * 60 * 60);
    if (diffHours < 1) {
      const diffMinutes = diffMs / (1000 * 60);
      const mins = Math.round(diffMinutes);
      return `${mins} minute${mins !== 1 ? 's' : ''} ago`;
    }
    const hours = Math.round(diffHours);
    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  } else if (diffDays < 7) {
    const days = Math.round(diffDays);
    return `${days} day${days !== 1 ? 's' : ''} ago`;
  } else if (diffDays < 30) {
    const weeks = Math.round(diffDays / 7);
    return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
  } else {
    return date.toLocaleString(undefined, {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });
  }
}